var map = {
	"./arrow-left.svg": "ac3b",
	"./avatar.svg": "f2e9",
	"./calendar.svg": "b8bd",
	"./cancel.svg": "b463",
	"./check-mark.svg": "2677",
	"./chevron-thin-down.svg": "5b8a",
	"./delivery.svg": "4a78",
	"./delivery2.svg": "1d90",
	"./error.svg": "28c3",
	"./facebook.svg": "8485",
	"./fp-minus.svg": "47c2",
	"./fp-plus.svg": "85a5",
	"./help-circle.svg": "a530",
	"./insta.svg": "6520",
	"./linkedin.svg": "9ed9",
	"./minus.svg": "3e24",
	"./password-eye.svg": "9c6e",
	"./pencel.svg": "2680",
	"./phone.svg": "c3bb",
	"./pinterest.svg": "17dd",
	"./plus.svg": "eb38",
	"./success.svg": "1c27",
	"./tick-success.svg": "1ff9",
	"./tick.svg": "812c",
	"./twitter.svg": "acf9",
	"./youtube.svg": "11ef"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b422";